<template>
    <form class="forgot-form">
        <div class="forgot-form-main">
                <Input 
                    v-model="password" 
                    label="Пароль" 
                    type="password" 
                    required/>
                <Input
                    v-model="repeat" 
                    label="Повторите пароль" 
                    type="password" 
                    required/>
        </div>
        <div class="controls-row">
            <div class="btn-wrap">
                <Btn primary :to="{ name: 'login' }">Отменить</Btn>
            </div>
            <div class="btn-wrap">
                <Btn danger>Сохранить</Btn>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: "DesktopForgotForm",
    data: () => ({
        password: '',
        repeat: '',
    }),
};
</script>

<style lang="scss" scoped>
    .forgot-form{
        padding: 0;
        height: 535px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &-main {
            margin-top: 150px;
        }
    }
    .form-title {
        font-family: "Futura PT", sans-serif;
        font-size: 14px;
        line-height: 18px;

        color: #2A2626;
    }
    .form-group{
        position: relative;
        padding:10px;
        border: 1px solid #BAC5CB;
        border-radius: 4px;
        margin: 25px 0;
        height: 50px;
        box-sizing: border-box;
    }
    .form-group>label{
        position: absolute;
        top: -8px;
        left: 10px;
        padding-left: 10px;
        font-size: 12px;
        padding-right: 10px;
        background-color: white;
    }
    .form-group>input{
        border:none;
        outline: none;
        height: 100%;
        width: 100%;
    }
    .btn-wrap{
        margin-top: 20px;
        box-sizing: border-box;
        padding: 5px;
        width: 50%;
        display: inline-block;
    }
    .back-btn{
        width: 100%;
        margin-left: -5px;
        background-color: #3874E0;
    }
    .forgot-btn{
        width: 100%;
        margin-right: -5px;
        background-color: #D1004A;
    }


</style>